"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.components_de_de = void 0;
function components_de_de() {
    return {
        "components.container.direction.vertical": "Vertikal",
        "components.container.direction.horizontal": "Horizontal",
        "components.container.flexattributes.flex-start": "Start",
        "components.container.flexattributes.center": "Center",
        "components.container.flexattributes.flex-end": "Ende",
        "components.container.flexattributes.stretch": "Ausdehnen",
        "components.container.flexattributes.normal": "Normal",
        "components.container.flexattributes.space-between": "Mit Platz dazwischen",
        "components.container.flexattributes.space-around": "Mit Platz außen herum",
        "components.container.flexattributes.space-evenly": "Platz gleichmäßig verteilt",
        "components.crm.contacts.detail.title": "Kontaktdetails",
        "components.crm.contacts.avatar": "Bild",
        "components.crm.contacts.firstname": "Vorname",
        "components.crm.contacts.lastname": "Nachname",
        "components.crm.contacts.email": "E-Mail",
        "components.crm.contacts.phone": "Telefon",
        "components.crm.contacts.mobile": "Mobiltelefon",
        "components.crm.contacts.birthday": "Geburtstag",
        "components.crm.contacts.address": "Private Adresse",
        "components.crm.contacts.company": "Firmenname",
        "components.crm.contacts.companyposition": "Position",
        "components.crm.contacts.companyphone": "Geschäftliche Telefonnummer",
        "components.crm.contacts.companyaddress": "Firmenadresse",
        "components.crm.contacts.deletion.title": "Kontakt löschen",
        "components.crm.contacts.deletion.message": "Wollen Sie diesen Kontakt wirklich löschen?",
        "components.editors.monaco.editorloading": "Editor wird geladen",
        "components.editors.styleeditor.csstitle": "Benutzerdefinierte Styles",
        "components.editors.styleeditor.cssclasstitle": "Eigene CSS Klassen",
        "components.editors.styleeditor.cssclasshint": "Fügen Sie hier Ihre eigenen CSS Klassen hinzu",
        "components.editors.styleeditor.addnewstyle": "Neuen Style hinzufügen",
        "components.passwordreset.title": "Passwort-Wiederherstellung",
        "components.passwordreset.verificationtext": "Bitte geben Sie hier Ihre E-Mail Adresse ein. Wir senden Ihnen alle erforderlichen Information per Mail zu!",
        "components.passwordreset.sendresetmailbtn": "Wiederherstellungsmail senden",
        "components.passwordreset.pendingtext": "Eine E-Mail mit weiteren Anweisungen wurde verschickt, bitte prüfen Sie Ihr Postfach!",
        "components.passwordreset.newpasswordtext": "Bitte geben Sie Ihr neues Passwort ein!",
        "components.passwordreset.changepasswordbtn": "Passwort ändern",
        "components.passwordreset.fields.email.label": "Registrierte E-Mail Adresse",
        "components.passwordreset.fields.resettoken.label": "Wiederherstellungs-Token",
        "components.passwordreset.fields.password.label": "Neues Passwort",
        "components.passwordreset.messages.nopasswordgiven": "Kein Password eingegeben!",
        "components.passwordreset.messages.passwordsdontmatch": "Passwörter stimmen nicht überein!",
        "components.passwordreset.messages.nomailgiven": "Keine E-Mail angegeben!",
        "components.passwordreset.messages.novalidmailgiven": "Die eingegebene E-Mail Adresse ist ungültig!",
        "components.passwordreset.passwordresetmailsent": "Bitte überprüfen Sie Ihr E-Mail Postfach. Falls wir ein Benutzerprofil mit dieser E-Mail Adresse gefunden haben, sollen Sie bereits eine Mail mit weiteren Instruktionen erhalten haben.",
        "components.passwordreset.expiredtoken": "Das Passwort Token ist abgelaufen!",
        "components.passwordreset.unknowntoken": "Das Passwort Token ist ungültig!",
        "components.passwordreset.passwordset": "Ihr neues Passwort wurde erfolgreich gespeichert!",
        "components.passwordreset.newtoken.text": "Falls das Token bereits abgelaufen sein sollte oder ein anderes Problem aufgetreten ist, können Sie hier ein neues erstellen",
        "components.passwordreset.newtoken.link": "Neues Token anfordern",
        "components.passwordfield.password.label": "Neues Passwort",
        "components.login.label": "Anmeldung",
        "components.login.description": "Bitte melden Sie sich mit Ihren Anmeldedaten an!",
        "components.login.loginbutton": "Anmelden",
        "components.login.emailpassword.fields.email.label": "E-Mail",
        "components.login.emailpassword.fields.password.label": "Passwort",
        "components.login.registration.label": "Sie haben noch keinen Account?",
        "components.login.registration.link": "Hier registrieren",
        "components.login.loginbtn": "Anmelden",
        "components.login.headline": "Melden Sie sich mit Ihrem Account an",
        "components.login.mail": "E-Mail",
        "components.login.password": "Passwort",
        "components.login.remembercredentials": "Zugangsdaten merken",
        "components.login.notregistered": "Noch kein Konto?",
        "components.login.registerhere": "Hier registrieren",
        "components.login.forgotpassword": "Passwort vergessen",
        "components.login.alreadyloggedin": "Sie sind bereits angemeldet!",
        "components.login.errors.noauthenticationdetailsprovided": "Keine Anmeldedaten geliefert!",
        "components.login.errors.noauthenticationtypeprovided": "Kein Anmeldetyp definiert!",
        "components.login.errors.unknownauthtype": "Unbekannter Anmeldetyp definiert!",
        "components.login.errors.noemailgiven": "Keine E-Mail angegeben!",
        "components.login.errors.nopasswordgiven": "Kein Passwort angegeben!",
        "components.login.errors.unknownemailpassword": "Unbekannte E-Mail/Passwort Kombination!",
        "components.login.errors.userdeactivated": "Benutzer ist deaktiviert und kann deshalb nicht angemeldet werden!",
        "components.login.errors.invalidtoken": "Das Authentifizierungstoken ist ungültig, bitte melden Sie sich erneut an!",
        "components.registration.email": "E-Mail",
        "components.registration.password": "Passwort",
        "components.registration.invitetoken.label": "Einladungsschlüssel",
        "components.registration.login.label": "Bereits registriert?",
        "components.registration.login.link": "Zurück zur Anmeldung",
        "components.registration.title": "Registrierung",
        "components.registration.message": "Registrieren Sie sich mit Ihrer E-Mail Adresse und einem Passwort und los gehts!",
        "components.registration.registerbtn": "Konto erstellen",
        "components.registration.hint": "Hinweis: Sie können das Passwort anzeigen, indem Sie auf das Auge drücken!",
        "components.registration.messages.lowercase": "mindestens ein kleingeschriebener Buchstabe",
        "components.registration.messages.uppercase": "mindestens ein großgeschriebener Buchstabe",
        "components.registration.messages.minchars": "mindestens ${min} Zeichen",
        "components.registration.messages.specialchar": "mindestens ein Sonderzeichen",
        "components.registration.messages.digit": "mindestens eine Zahl",
        "components.registration.messages.passwordset": "Ihr Passwort wurde erfolgreich geändert!",
        "components.registration.messages.invalidemail": "E-Mail Format ungültig. Bitte verwenden Sie eine E-Mail Adresse wie hello@mail.com",
        "components.registration.messages.errortext": "Während Ihrer Registrierung ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Formulareingaben und versuchen Sie es erneut.",
        "components.mailverification.title": "E-Mail Verifizierung",
        "components.mailverification.message": "Vielen Dank für die Verifizierung Ihrer E-Mail. Sie können sich nun am System anmelden.",
        "components.mailverification.titlemessageverificationsent": "E-Mail versendet",
        "components.mailverification.messageverificationsent": "Ein neuer Verifizierungslink wurde per E-Mail versendet.",
        "components.mailverification.invalidtoken": "Das angegebene E-Mail Verifizierungstoken ist ungültig!",
        "components.mailverification.verificationmessage": "Bitte verifizieren Sie Ihre E-Mail Adresse '${email}'. Wir senden Ihnen hierfür eine E-Mail mit einem Bestätigungslink.",
        "components.mailverification.button": "E-Mail erneut senden",
        "components.mailverification.success.title": "Erfolgreich!",
        "components.mailverification.success.message": "Ihre E-Mail wurde erfolgreich verifiziert.",
        "components.mailverification.error.title": "Verifizierungsfehler",
        "components.mailverification.error.token.expired": "Der Verifizierungstoken ist leider abgelaufen.",
        "components.mailverification.error.token.invalid": "Der Verifizierungstoken ist ungültig.",
        "components.mailverification.error.token.notprovided": "Der Verifizierungstoken wurde leider nicht übermittelt.",
        "components.mailverification.error.token.usernotfound": "Der Benutzer wurde nicht gefunden.",
        "components.pager.itemsperpagelabel": "pro Seite",
        "components.pager.firstpagelabel": "Erste Seite",
        "components.pager.nextpagelabel": "Nächste Seite",
        "components.pager.previouspagelabel": "Vorherige Seite",
        "components.pager.lastpagelabel": "Letzte Seite",
        "components.pager.of": "von",
        "components.register.headline": "Neues Konto anlegen",
        "components.register.confirmpassword": "Passwort bestätigen",
        "components.register.register": "Registrieren",
        "components.register.registered": "Bereits registriert?",
        "components.register.backtologin": "Hier geht's zur Anmeldung",
        "components.register.alreadyloggedin": "Sie sind derzeit bereits angemeldet. Falls Sie einen weiteren Benutzer registieren möchten, melden Sie sich bitte zuerst ab!",
        "components.register.passwordinvalid": "Das angegebene Passwort entspricht nicht den Sicherheitsanforderungen!",
        "components.register.passwordconfirmationinvalid": "Das wiederholte Passwort stimmt nicht überein!",
        "components.cmsslot.add": "neue Komponente hinzufügen",
        "components.cmscatalog.selectcomponent": "Komponente auswählen",
        "components.flexcontainer.add": "neue Komponente zu Flex Container hinzufügen",
        "components.list.emptymessage": "Keine Daten gefunden",
        "components.list.headers.actions": "Aktionen",
        "components.loader.loadingdata": "Daten werden geladen",
        "components.cardboxes.actions.open": "öffnen",
        "components.cardboxes.actions.del": "löschen",
        "components.cardboxes.actions.edit": "ändern",
        "components.cardboxes.actions.send": "senden",
        "components.storeselect.selectcurrentpage": "Alles auswählen",
        "components.storeselect.unselectcurrentpage": "Alles abwählen",
        "components.siterefresh.title": "Neue Version verfügbar",
        "components.siterefresh.message": "Eine neue Version dieser Webseite ist verfügbar. Die Seite muss neu geladen werden, damit die Änderungen wirksam weden.",
        "components.siterefresh.refresh": "Neu laden",
        "components.siterefresh.later": "Später",
        "components.deletedialog.title": "Löschen bestätigen",
        "components.deletedialog.message.xyz": "Möchten Sie die Datei '${file}' wirklich löschen?",
        "components.deletedialog.message.invitationslist": "Möchten Sie diesen Datensatz wirklich löschen?",
        "components.deletedialog.message.accesstoken": "Möchten Sie diesen Access Token wirklich löschen?",
        "components.deletedialog.message.custombackoffice": "Möchten Sie diesen Datensatz wirklich löschen?",
        "components.deletedialog.message.files": "Möchten Sie die Datei wirklich löschen?",
        "components.deletedialog.message.app": "Möchten Sie diese App wirklich löschen?",
        "components.deletedialog.message.checkincontact": "Möchten Sie diesen Kontakt wirklich löschen?",
        "components.deletedialog.message.checkinprinter": "Möchten Sie diese Druckerkonfiguration wirklich löschen?",
        "components.deletedialog.message.devices": "Möchten Sie dieses Gerät wirklich löschen?",
        "components.deletedialog.message.languageeditor": "Möchten Sie diese Sprache wirklich löschen?",
        "components.deletedialog.message.countryeditor": "Möchten Sie dieses Land wirklich löschen?",
        "components.deletedialog.message.localeeditor": "Möchten Sie diese Sprachumgebung wirklich löschen?",
        "components.deletedialog.message.translations": "Möchten Sie diese Übersetzung wirklich löschen?",
        "components.deletedialog.message.products": "Möchten Sie dieses Produkt wirklich löschen?",
        "components.deletedialog.message.pricezone": "Möchten Sie diese Preiszone wirklich löschen?",
        "components.deletedialog.message.supplier": "Möchten Sie diese Zulieferer wirklich löschen?",
        "components.deletedialog.message.price": "Möchten Sie diesen Preis wirklich löschen?",
        "components.deletedialog.message.productoption": "Möchten Sie diese Produktoption wirklich löschen?",
        "components.deletedialog.message.productpicture": "Möchten Sie diese Produktbild wirklich löschen?",
        "components.deletedialog.message.productmeta": "Möchten Sie diese Daten wirklich löschen?",
        "components.deletedialog.message.configuration": "Möchten Sie diese Konfiguration wirklich löschen?",
        "components.deletedialog.message.emailtemplate": "Möchten Sie diese E-Mail Vorlage wirklich löschen?",
        "components.deletedialog.message.cms": "Wollen Sie diese CMS Seite mit allen lokaliserten Inhalten, Tags und Metadaten wirklich löschen?",
        "components.deletedialog.message.cmsmeta": "Möchten Sie diese Daten wirklich löschen?",
        "components.deletedialog.message.optin": "Möchten Sie diese Einverständniserklärung wirklich löschen?",
        "components.deletedialog.message.calendar": "Möchten Sie den Kalender '${calendar}' wirklich löschen?",
        "components.deletedialog.delete": "Endgültig löschen",
        "components.deletedialog.cancel": "Abbrechen",
        "components.deletedialog.success.title": "Erfolgreich gelöscht",
        "components.deletedialog.success.message": "Die Datei wurde erfolgreich gelöscht.",
        "components.actionbutton.clipboard": "In Zwischenablage kopiert",
        "components.inlinetranslation.replacement.title": "Übersetzung entfernen",
        "components.inlinetranslation.replacement.message": "Wollen Sie wirklich alle Übersetzungen löschen und durch den aktuell angezeigten Text ersetzen?",
        "components.calendar.entryform.content": "Details",
        "components.calendar.entryform.title": "Titel",
        "components.calendar.entryform.location": "Ort",
        "components.calendar.entryform.start": "Beginn",
        "components.calendar.entryform.end": "Ende",
        "components.calendar.entryform.calendarid": "Kalender",
        "components.calendar.entryform.tags": "Tags",
        "components.calendar.entryform.category": "Kategorien",
        "components.calendar.entryform.attendeeids": "Teilnehmer",
        "components.cms.editor.widgets.removetitle": "Widget entfernen",
        "components.cms.editor.widgets.removemessage": "Wollen Sie dieses Widget wirklich löschen? Alle zugehörigen Daten werden ebenfalls gelöscht.",
        "components.cms.configuration.noconfig": "Keine Konfiguration möglich",
        "components.qrcodeimage.aspng": "PNG Bild Datei",
        "components.qrcodeimage.assvg": "SVG Vektorgrafik",
        "components.links.title": "Verknüpfungen",
        "components.links.unknowntype": "Unbekannter Typ",
        "components.links.labels.customer": "Kunde",
        "components.links.reversedlinks.nonefound": "Keine Verknüpfungen gefunden",
        "components.microsoftfiles.nofolderset": "Kein Ordner angegeben",
        "components.microsoftfiles.changefolder": "Ordner wechseln",
        "components.microsoftfiles.setfolder": "Ordner setzen",
        "components.microsoftfiles.openfolder": "Ordner öffnen",
        "components.microsoftfiles.removefolder": "Verlinkung aufheben",
        "components.microsoftfiles.dialogtitle": "Microsoft 365 Verzeichnis wählen",
        "components.microsoftfiles.directoryup": "Ebene höher",
        "components.microsoftfiles.nodrive": "Kein Sharepoint Verzeichnis verlinkt",
        "components.orders.orderdate": "Bestelldatum",
        "components.orders.orderer": "Besteller",
        "components.orders.empty": "Keine Bestellungen gefunden",
        "components.cartdetails.pleaselogin": "Bitte melden Sie sich an, um den Warenkorb nutzen zu können",
        "components.cartdetails.ordernow": "jetzt bestellen",
        "components.cartdetails.total": "Gesamtpreis",
        "components.cartdetails.noitems": "Ihr Warenkorb ist leer",
        "components.search.advancedsearch": "Erweiterte Suche",
        "components.search.contains": "beinhaltet",
        "components.search.matches": "ist gleich",
        "components.search.matcher.exactmatch": "ist gleich",
        "components.search.matcher.equals": "ist gleich",
        "components.search.matcher.includes": "beinhaltet",
        "components.search.matcher.startswith": "beginnt mit",
        "components.search.matcher.endswith": "endet mit",
        "components.search.matcher.exists": "Feld existiert",
        "components.search.matcher.greaterthan": "größer als",
        "components.search.matcher.greaterthanequals": "größer gleich",
        "components.search.matcher.lessthan": "kleiner als",
        "components.search.matcher.lessthanequals": "kleiner gleich",
        "components.search.matcher.beforerelativetime": "vor der relativen Zeit",
        "components.search.matcher.afterrelativetime": "nach der relativen Zeit",
        "components.search.matcher.inrelativemonth": "innerhalb des angegebenen Monats",
        "components.storesearch.mode.simple": "einfach",
        "components.storesearch.mode.advanced": "erweitert",
        "components.storesearch.comperator.or": "oder",
        "components.storesearch.comperator.and": "und",
        "components.storesearch.placeholder": "Nach ${value} suchen",
        "components.table.field": "Feld",
        "components.table.key": "Schlüssel",
        "components.table.value": "Wert",
        "components.table.addentry.text": "Text",
        "components.table.addentry.number": "Nummer",
        "components.table.addentry.boolean": "Ja/Nein"
    };
}
exports.components_de_de = components_de_de;
